import React from 'react';

import { useCategoryState } from '@atlas/core';

export default function CategoryLoader(props) {
  const { initialized, loading } = useCategoryState();

  if (!initialized && loading) {
    return null;
  }

  return props.children;
}
